import React, { Children, useMemo } from 'react';
import { DynamicSplitLayoutSlot } from './DynamicSplitLayoutSlot';
import styles from './DynamicSplitLayout.scss';
export const DynamicSplitLayout = _ref => {
  let {
    children,
    ratio = 50,
    gap = 0
  } = _ref;
  const slots = Children.toArray(children).slice(0, 2);
  const [left, right] = useMemo(() => slots.map((slot, index) => {
    const isFirst = index === 0;
    const isSingle = slots.length === 1;
    const firstRatio = isSingle ? 100 : ratio;
    const width = isFirst ? firstRatio : 100 - firstRatio;
    return /*#__PURE__*/React.createElement(DynamicSplitLayoutSlot, {
      key: `slot-${index}`,
      width: width
    }, slot);
  }), [slots, ratio]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.dynamicSplitLayout,
    style: {
      gap: `${gap}px`
    }
  }, left, right);
};
//# sourceMappingURL=DynamicSplitLayout.js.map